// extracted by mini-css-extract-plugin
export var currencyInput = "_kc-1";
export var currencySymbol = "_kc-0";